<!-- tab-layout.component.html -->
<ul class="nav nav-tabs" id="myTab" role="tablist">
  <li class="nav-item" *ngFor="let tab of tabs; let i = index">
    <a class="nav-link"  [class.active]="i === activeTab"
      (click)="loadComponent(i)">{{ tab.title }}</a>
  </li>
</ul>
<div class="tab-content">
  <div class="tab-pane">
    <router-outlet></router-outlet>
  </div>
</div>
